import Python from "../../assets/skills/python.png";
import NextJS from "../../assets/skills/nextjs.png";
import Express from "../../assets/skills/expressjs.png";
import ReactJS from "../../assets/skills/reactjs.png";
import Redux from "../../assets/skills/redux.png";
import NodeJS from "../../assets/skills/nodejs.png";
import HTML from "../../assets/skills/html.png";
import CSS from "../../assets/skills/css.png";
import TailwindCSS from "../../assets/skills/tailwindcss.png";
import JavaScript from "../../assets/skills/javascript.png";
import TypeScript from "../../assets/skills/typescript.png";
import MongoDB from "../../assets/skills/mongodb.png";
import Git from "../../assets/skills/git.png";
import Postman from "../../assets/skills/postman.png";

export const skillsData = [
  {
    id: 1,
    image: Python,
    name: "Python",
  },
  {
    id: 2,
    image: ReactJS,
    name: "ReactJS",
  },
  {
    id: 3,
    image: NextJS,
    name: "NextJS",
  },
  {
    id: 4,
    image: NodeJS,
    name: "NodeJS",
  },
  {
    id: 5,
    image: Express,
    name: "ExpressJS",
  },
  {
    id: 6,
    image: MongoDB,
    name: "MongoDB",
  },
  {
    id: 7,
    image: Redux,
    name: "Redux",
  },
  {
    id: 8,
    image: HTML,
    name: "HTML",
  },
  {
    id: 9,
    image: CSS,
    name: "CSS",
  },
  {
    id: 10,
    image: JavaScript,
    name: "JavaScript",
  },
  {
    id: 11,
    image: TypeScript,
    name: "TypeScript",
  },
  {
    id: 12,
    image: TailwindCSS,
    name: "TailwindCSS",
  },
  {
    id: 13,
    image: Git,
    name: "Git",
  },
  {
    id: 14,
    image: Postman,
    name: "Postman",
  },

];
